
const firebaseConfig = {
  // apiKey: process.env.REACT_APP_API_KEY,
  // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_MESSING_SENDER_ID,
  // appId: process.env.REACT_APP_APP_ID,

  // trying but not working .env.local

  apiKey: "AIzaSyB3A_kJTGrkL3yNIax-FAtQyYKj1hbPX40",
  authDomain: "car-vana.firebaseapp.com",
  projectId: "car-vana",
  storageBucket: "car-vana.appspot.com",
  messagingSenderId: "902613136426",
  appId: "1:902613136426:web:51565f026037f04c43ff53"
}

export default firebaseConfig;
